module.exports = __webpack_public_path__ + "static/media/cool-emoji-svgrepo-com (2).cf674ad7.svg";